import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import { Program }          from "Utils/API";
import Action               from "dashboard/dist/Core/Action";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import ProgramEdit          from "./ProgramEdit";
import Main                 from "dashboard/dist/Components/Main";
import Header               from "dashboard/dist/Components/Header";
import ActionList           from "dashboard/dist/Components/ActionList";
import Content              from "dashboard/dist/Components/Content";
import Table                from "dashboard/dist/Components/Table";
import TableHead            from "dashboard/dist/Components/TableHead";
import TableBody            from "dashboard/dist/Components/TableBody";
import TableRow             from "dashboard/dist/Components/TableRow";
import TableHeader          from "dashboard/dist/Components/TableHeader";
import TableCell            from "dashboard/dist/Components/TableCell";
import TablePaging          from "dashboard/dist/Components/TablePaging";
import TableActionList      from "dashboard/dist/Components/TableActionList";
import TableAction          from "dashboard/dist/Components/TableAction";
import DeleteDialog         from "dashboard/dist/Components/DeleteDialog";
import Downloader           from "dashboard/dist/Components/Downloader";

// Actions
import {
    fetchPrograms, deleteProgram,
} from "Actions/Admin/Program/ProgramActions";



/**
 * The Program List
 */
class ProgramList extends React.Component {
    // The Current State
    state = {
        action : Action.get(),
        elemID : 0,
    }

    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        this.fetch();
    }

    /**
     * Fetch the content
     * @param {Object=} params
     * @returns {Void}
     */
    fetch = (params) => {
        const { type, elemID, data } = this.props;
        this.props.fetchPrograms(type, elemID, params || data.sort);
    }



    /**
     * Starts an Action
     * @param {Object} action
     * @param {Number} elemID
     * @returns {Void}
     */
    startAction = (action, elemID) => {
        this.setState({ action, elemID });
    }

    /**
     * Ends an Action
     * @returns {Void}
     */
    endAction = () => {
        this.startAction(Action.get(), 0);
    }



    /**
     * Handles the Edit Submit
     * @returns {Void}
     */
    editElem = () => {
        this.endAction();
        this.fetch();
    }

    /**
     * Handles the Delete Submit
     * @returns {Promise}
     */
    deleteElem = async () => {
        const elemID = this.state.elemID;
        this.endAction();
        await this.props.deleteProgram(elemID);
        this.fetch();
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { action, elemID                      } = this.state;
        const { data, params, route, withDetails    } = this.props;
        const { canEdit, list, total, sort, loading } = data;

        const elemName   = Utils.getValue(list, "programID", elemID, "name");
        const hideCourse = Boolean(params.courseID);

        return <Main withDetails={withDetails}>
            <Header message="PROGRAMS_NAME" icon="program" route={route}>
                <ActionList data={data} onAction={this.startAction} />
            </Header>
            <Content isLoading={loading}>
                <Table fetch={this.fetch} sort={sort} none="PROGRAMS_NONE_AVAILABLE">
                    <TableHead>
                        <TableHeader field="name"       message="GENERAL_NAME"          grow="1.5" bigMobile />
                        <TableHeader field="title"      message="GENERAL_STUDENT_TITLE" grow="1.5" bigMobile />
                        <TableHeader field="type"       message="GENERAL_TYPE"          />
                        <TableHeader field="courseName" message="COURSES_SINGULAR"      isHidden={hideCourse} />
                        <TableHeader field="position"   message="GENERAL_POSITION"      maxWidth="80" align="center" hideMobile />
                    </TableHead>
                    <TableBody>
                        {list.map((elem) => <TableRow key={elem.programID} elemID={elem.programID}>
                            <TableCell message={elem.name}       circle={elem.statusColor} />
                            <TableCell message={elem.title}      />
                            <TableCell message={elem.typeName}   />
                            <TableCell message={elem.courseName} />
                            <TableCell message={elem.position}   />
                        </TableRow>)}
                    </TableBody>
                    <TablePaging total={total} />
                    <TableActionList onAction={this.startAction} canEdit={canEdit}>
                        <TableAction action="VIEW"   message="PROGRAMS_VIEW_TITLE"   route={route} />
                        <TableAction action="EDIT"   message="PROGRAMS_EDIT_TITLE"   />
                        <TableAction action="DELETE" message="PROGRAMS_DELETE_TITLE" />
                    </TableActionList>
                </Table>
            </Content>

            <ProgramEdit
                open={action.isVCE}
                elemID={elemID}
                courseID={params.courseID}
                onSubmit={this.editElem}
                onClose={this.endAction}
            />
            <DeleteDialog
                open={action.isDelete}
                title="PROGRAMS_DELETE_TITLE"
                message="PROGRAMS_DELETE_TEXT"
                content={elemName}
                onSubmit={this.deleteElem}
                onClose={this.endAction}
            />
            <Downloader
                download={action.isExport}
                source={Program.export()}
                onLoad={this.endAction}
            />
        </Main>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchPrograms : PropTypes.func.isRequired,
        deleteProgram : PropTypes.func.isRequired,
        data          : PropTypes.object.isRequired,
        type          : PropTypes.string.isRequired,
        params        : PropTypes.object.isRequired,
        route         : PropTypes.string.isRequired,
        withDetails   : PropTypes.bool.isRequired,
        elemID        : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            data : state.program,
        };
    }
}

export default connect(ProgramList.mapStateToProps, {
    fetchPrograms, deleteProgram,
})(ProgramList);
